function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgOtherCardio(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 30,
    height: 30,
    viewBox: "0 2 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Path, {
    d: "M17.014 7.175a2.586 2.586 0 002.9-2.906 2.593 2.593 0 00-2.228-2.248 2.586 2.586 0 00-2.9 2.906c.153 1.177 1.084 2.11 2.228 2.248z",
    fill: props.fill
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M20.875 13.689c.29.244.67.351 1.052.29.382-.046.718-.26.931-.565l3.357-4.74a1.37 1.37 0 00-2.228-1.591L21.47 10.63c-.733-.871-2.411-2.584-5.051-3.241a8.833 8.833 0 00-2.228-.276c-1.846.123-3.677.26-5.523.383a1.39 1.39 0 00-1.282 1.269l-.382 5.275a1.361 1.361 0 001.267 1.468 1.36 1.36 0 001.465-1.269l.29-4.083 2.777-.198-.351 5.658c-.092.749.122 1.865 1.007 2.599.152.122.305.23.442.306l-.488 6.3-2.396 5.979a1.37 1.37 0 00.763 1.789c.168.061.336.092.504.092.55 0 1.053-.321 1.282-.872l2.472-6.178a1.68 1.68 0 00.091-.397l.504-6.254h3.936l-1.358 5.199a1.376 1.376 0 001.328 1.728c.61 0 1.16-.413 1.327-1.025l1.8-6.896a1.391 1.391 0 00-.243-1.193 1.365 1.365 0 00-1.084-.535h-4.852l.64-4.802 2.748 2.233z",
    fill: props.fill
  }));
}

export default SvgOtherCardio;